import {
  Component,
  Input,
  Output,
  EventEmitter,
  effect,
  model,
  signal,
  inject,
  computed,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CategoryOpenSearch } from '../../../enums/category-open-search';
import { CategoriesQuickSearch } from '../../../models/categories-quick-search';
import { TranslateModule } from '@ngx-translate/core';
import { CategoryIconPipe } from '../../../pipes/category-icon.pipe';
import { OpenSearchService } from '../../../services/open-search.service';
import { AnswerSearch } from '../../../models/recent-search';
import { ClassCategoryOpenSearchPipe } from '../../../pipes/class-category-open-search.pipe';
import { ChangeLanguagePipe } from '../../../pipes/change-language.pipe';
import { SearchPanelComponent } from '../search-panel/search-panel.component';
import { MultiLangService } from '../../../services/multi-lang.service';
@Component({
  selector: 'app-select-category',
  imports: [
    CommonModule,
    TranslateModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    ChangeLanguagePipe,
  ],
  templateUrl: './select-category.component.html',
  styleUrls: ['./select-category.component.scss'],
})
export class SelectCategoryComponent {
  @Input() selected: CategoryOpenSearch = CategoryOpenSearch.DEFAULT;
  @Input() categories: CategoriesQuickSearch[] = [];
  @Output() selectedChange = new EventEmitter<CategoryOpenSearch>();
  searchPanel = inject(SearchPanelComponent);
  multiLangService = inject(MultiLangService);
  categoryOptions = model<CategoriesQuickSearch[]>([]);
  items = model<AnswerSearch[]>();
  filteredItems = model<AnswerSearch[]>();
  selectedCategory = signal<CategoriesQuickSearch>({} as CategoriesQuickSearch);
  optionAllcategoriies = signal<CategoriesQuickSearch>({} as CategoriesQuickSearch);
  selectControl = new FormControl(CategoryOpenSearch.ALL);
  searchPanelSignal = computed(() => this.searchPanel.showAll());
  readonly ALL_CATEGORIES_KEY = 'OPEN_SEARCH.ALL_CATEGORIES';
  showSearch = false;
  searchText = model<string>('');
  constructor(
    private openSearchService: OpenSearchService,
    private categoryIconPipe: CategoryIconPipe,
    private classCategoryOpenSearchPipe: ClassCategoryOpenSearchPipe,
  ) {
    this.effectFilteredItemsBySearchText();
    this.optionAllcategoriies.set({
      value: CategoryOpenSearch.ALL,
      label: {} as any,
      icon: this.categoryIconPipe.transform(0),
      selected: true,
      class: this.classCategoryOpenSearchPipe.transform(CategoryOpenSearch.ALL),
    });
    this.selectedCategory.set(this.optionAllcategoriies());
    this.setCategoriesOptions();
    this.setSelectedOption();
  }
  filterItemsBySearchText(items: AnswerSearch[], searchText: string, lang: string): AnswerSearch[] {
    const search = (searchText || '').toLowerCase();
    if (search.length > 0) {
      return (items || []).filter((item: AnswerSearch) => {
        const text = (item.text[lang as keyof typeof item.text] || '').toLowerCase();
        return text.includes(search);
      });
    }
    return items || [];
  }

  effectFilteredItemsBySearchText() {
    effect(() => {
      const filtered = this.filterItemsBySearchText(
        this.items() || [],
        this.searchText() || '',
        this.multiLangService.getStoredLanguage(),
      );
      this.filteredItems.set(filtered);
    });
  }

  setSelectedOption() {
    this.selectControl.valueChanges.subscribe(value => {
      const updateSelected = this.categoryOptions().map(option => {
        option.selected = option.value === value;
        return option;
      });

      const selectedCaregory = updateSelected.find(x => x.selected);
      this.selectedCategory.set(selectedCaregory || ({} as CategoriesQuickSearch));

      this.categoryOptions.set(updateSelected);
      this.filteredQuickItems();
    });
  }

  setCategoriesOptions() {
    this.openSearchService.getCategories();
    effect(() => {
      const categories = this.openSearchService.categories();
      if (categories) {
        this.categoryOptions.set([
          ...[this.optionAllcategoriies()],
          ...categories.map(c => ({
            value: c.id,
            label: c.text,
            icon: this.categoryIconPipe.transform(c.id),
            selected: false,
            class: this.classCategoryOpenSearchPipe.transform(c.id),
          })),
        ]);
      }
    });
  }
  toggleSearch() {
    this.showSearch = !this.showSearch;
  }

  closeSearch() {
    if (!this.searchText()) {
      this.showSearch = false;
    }
  }

  filteredQuickItems(): AnswerSearch[] {
    const items = this.items() || [];
    if (items.length > 0) {
      this.openSearchService.getPromts(Number(this.selectedCategory().value || 0), false);
      switch (this.selectedCategory().value) {
        case CategoryOpenSearch.HEALTH:
          return items.slice(0, 2);
        case CategoryOpenSearch.MIGRATION:
          return items.slice(2, 4);
        case CategoryOpenSearch.EDUCATION:
          return items.slice(4, 6);
        default:
          return items;
      }
    }

    return this.items() || [];
  }
}
